// Azordi "Charcoal Blue" brand palette — single source for category / service / staff colours & chart accents
export const BRAND = {
  primary: "#3E4552", primaryDark: "#2F3032", terracotta: "#B5704F", forest: "#3D5A45", tan: "#A38059",
  taupe: "#8C8880", sageGrey: "#B4B9B2", paleBlue: "#C5D3D8", blush: "#EDD1C7", sand: "#CFC5B4",
  offWhite: "#EEEDE8", border: "#E1DCD5", success: "#3D5A45", danger: "#DC2626",
};

// Deep enough to carry a white label and a readable tint on the diary
export const CATEGORY_COLORS = [
  "#3E4552", "#B5704F", "#3D5A45", "#A38059", "#6F8A7E", "#7A8B96",
  "#C08497", "#C9A66B", "#8C8880", "#5B6E7F", "#9B7C86", "#2F3032",
];

export const STAFF_COLORS = ["#3E4552", "#B5704F", "#3D5A45", "#A38059", "#7A8B96", "#C08497", "#6F8A7E", "#9B7C86"];

export const ACCENTS = { one: "#3E4552", two: "#B5704F", three: "#3D5A45", four: "#A38059", five: "#7A8B96", six: "#C08497" };
